/*
All fetch functions here accept a callback. The callback will more than likely
end up being a setState call in the component it is called from.
*/

import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };


// @GET
// @Path("view/{id}")
const viewRecord = (recordId, successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    `/api/records/view/${recordId}`,
    headers,
    successCallback,
    errorCallback,
  );
};

// @GET
// @Path("latest")
const getLatestRecord = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/records/latest',
    headers,
    successCallback,
    errorCallback,
  );
};

// @POST
// @Path("view/save-preferences")
const saveUserPreferences = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/records/view/save-preferences',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

// Currently returns the latest 5 records by default. This is defined in the java method explicitly.
// @GET
// @Path("list")
const getLastFiveRecords = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/records/list',
    headers,
    successCallback,
    errorCallback,
  );
};

// @params data = { startDate, endDate }
const recordSearch = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/records/search/',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const checkIfDirect = (address, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/records/verify-direct/',
    headers,
    JSON.stringify(address),
    successCallback,
    errorCallback,
  );
};

const transmitRecord = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/records/transmit/',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const getPossibleRecipients = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/records/possible-recipients/',
    headers,
    successCallback,
    errorCallback,
  );
};

const HealthApi = {
  viewRecord,
  getLatestRecord,
  getLastFiveRecords,
  recordSearch,
  saveUserPreferences,
  checkIfDirect,
  transmitRecord,
  getPossibleRecipients,
};

export default HealthApi;



// WEBPACK FOOTER //
// ./src/apis/health.js